import { createAction } from 'typesafe-actions';

import { type CollectionActionsFilterTypes, CollectionActions } from './constants';
import * as D from './deps';

interface IOffsetFilter {
  filter: CollectionActionsFilterTypes;
  offset: number;
}

type SetFetchingOffsetsPayload = IOffsetFilter;

export const setFetchingOffsets = createAction(
  CollectionActions.SET_FETCHING_OFFSETS,
  (offset: number, filter: CollectionActionsFilterTypes) => ({ offset, filter }),
)<SetFetchingOffsetsPayload>();
export type SetFetchingOffsetsAction = ReturnType<typeof setFetchingOffsets>;

type ResetFilterOffsetsPayload = Pick<IOffsetFilter, 'filter'>;

export const resetFilterOffsets = createAction(
  CollectionActions.RESET_FILTER_OFFSETS,
  (filter: CollectionActionsFilterTypes) => ({
    filter,
  }),
)<ResetFilterOffsetsPayload>();
export type ResetFilterOffsetsAction = ReturnType<typeof resetFilterOffsets>;

type SetFilterCurrentOffsetPayload = IOffsetFilter;

export const setFilterCurrentViewedOffset = createAction(
  CollectionActions.SET_FILTER_CURRENT_OFFSET,
  (filter: CollectionActionsFilterTypes, offset: number) => ({ filter, offset }),
)<SetFilterCurrentOffsetPayload>();
export type SetFilterCurrentOffsetAction = ReturnType<typeof setFilterCurrentViewedOffset>;

interface LoadFilterAtCurrentOffsetPayload {
  filter: CollectionActionsFilterTypes;
  forceLoad: boolean;
}

export const loadFilterAtCurrentOffset = createAction(
  CollectionActions.LOAD_FILTER_AT_CURRENT_OFFSET,
  (filter: CollectionActionsFilterTypes, forceLoad = false) => ({ filter, forceLoad }),
)<LoadFilterAtCurrentOffsetPayload>();
export type LoadFilterAtCurrentOffsetAction = ReturnType<typeof loadFilterAtCurrentOffset>;

interface AddRecentlyPlayedPodcastsParams {
  payload: $TSFixMe;
}

type AddRecentlyPlayedPodcastsPayload = AddRecentlyPlayedPodcastsParams['payload'];

export const addRecentlyPlayedPodcasts = createAction(
  CollectionActions.ADD_RECENTLY_PLAYED_PODCASTS,
  ({ payload }: AddRecentlyPlayedPodcastsParams) => payload,
)<AddRecentlyPlayedPodcastsPayload>();
export type AddRecentlyPlayedPodcastsAction = ReturnType<typeof addRecentlyPlayedPodcasts>;

interface RemoveRecentlyPlayedItemsParams {
  payload: $TSFixMe;
}

type RemoveRecentlyPlayedItemsPayload = RemoveRecentlyPlayedItemsParams['payload'];

export const removeRecentlyPlayedItems = createAction(
  CollectionActions.REMOVE_RECENTLY_PLAYED_ITEMS,
  ({ payload }: RemoveRecentlyPlayedItemsParams) => payload,
)<RemoveRecentlyPlayedItemsPayload>();
export type RemoveRecentlyPlayedItemsAction = ReturnType<typeof removeRecentlyPlayedItems>;

export const showedCollectionPage = createAction(D.ViewActions.SHOWED_COLLECTION_PAGE)();
export type ShowedCollectionPageAction = ReturnType<typeof showedCollectionPage>;

interface SetRecentlyPlayedSPSItemsParams extends $TSFixMe {}

export const setRecentlyPlayedSPSItems = createAction(
  CollectionActions.SET_RECENTLY_PLAYED_SPS_ITEMS,
  (params: SetRecentlyPlayedSPSItemsParams) => params,
)<SetRecentlyPlayedSPSItemsParams>();
export type SetRecentlyPlayedSPSItemsAction = ReturnType<typeof setRecentlyPlayedSPSItems>;

interface SetHasMetRecentlyPlayedThresholdPayload {
  hasMetRecentlyPlayedThreshold: boolean;
}

export const setHasMetRecentlyPlayedThreshold = createAction(
  CollectionActions.SET_HAS_MET_RECENTLY_PLAYED_THRESHOLD,
  (hasMetRecentlyPlayedThreshold: boolean) => ({ hasMetRecentlyPlayedThreshold }),
)<SetHasMetRecentlyPlayedThresholdPayload>();
export type SetHasMetRecentlyPlayedThresholdAction = ReturnType<
  typeof setHasMetRecentlyPlayedThreshold
>;

export const openPremiumWelcomeModal = createAction(CollectionActions.OPEN_PREMIUM_WELCOME_MODAL)();
export type OpenPremiumWelcomeModalAction = ReturnType<typeof openPremiumWelcomeModal>;
